<script>
export default {
  computed: {
    terms () {
      return [
        {
          title: 'I - INTRODUÇÃO',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent magna ante, iaculis at lectus non, condimentum vulputate eros. Nulla rhoncus semper lacus nec finibus. Ut risus mauris, aliquam id malesuada vel, iaculis eget dolor. Curabitur a dolor tristique, scelerisque nunc eget, dignissim augue. Donec lobortis elit nulla, sed lobortis nibh pretium in. Mauris mollis, nunc non dignissim maximus, elit risus bibendum tellus, eget finibus velit massa non mi.',
        },
        {
          title: 'II - QUAIS DADOS SÃO COLETADOS?',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent magna ante, iaculis at lectus non, condimentum vulputate eros. Nulla rhoncus semper lacus nec finibus. Ut risus mauris, aliquam id malesuada vel, iaculis eget dolor. Curabitur a dolor tristique, scelerisque nunc eget, dignissim augue. Donec lobortis elit nulla, sed lobortis nibh pretium in.',
        },
        {
          title: 'III - COMO SÃO UTILIZADOS OS DADOS?',
          content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent magna ante, iaculis at lectus non, condimentum vulputate eros.',
        },
      ];
    },
  },
};
</script>

<template>
  <main class="help-privacy">
    <h1 class="sidebar__title">Termos de Uso</h1>

    <p class="help__content">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      Praesent magna ante, iaculis at lectus non, condimentum vulputate eros.
      Nulla rhoncus semper lacus nec finibus. Ut risus mauris, aliquam id malesuada vel, iaculis eget dolor.
      Curabitur a dolor tristique, scelerisque nunc eget, dignissim augue.
      Donec lobortis elit nulla, sed lobortis nibh pretium in.
      Mauris mollis, nunc non dignissim maximus, elit risus bibendum tellus, eget finibus velit massa non mi.
    </p>

    <article>
      <section
        :key="index"
        class="help__term"
        v-for="({ title, content }, index) in terms"
      >
        <h2
          v-text="title"
          class="help__title"
        >
        </h2>
        <p
          v-text="content"
          class="help__content"
        >
        </p>
      </section>
    </article>
  </main>
</template>
